import React, { Component } from 'react';

import '../css/App.css';

class CountUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrolled: false,
      n: 0,
      end: 100000,
      number: '000000'
    };

    this.played = false;
    this.add = 1;
    this.interval = null;
  }

  componentDidMount() {
    if(window.innerWidth < 800) {
      this.start();
    }
  }

  render() {
    return (
      <div className="downloads">
        <div className="countup">
          <div className="number"><div className="number-inner">{this.state.number[0]}</div></div>
          <div className="number"><div className="number-inner">{this.state.number[1]}</div></div>
          <div className="number"><div className="number-inner">{this.state.number[2]}</div></div>
          <div className="number"><div className="number-inner">{this.state.number[3]}</div></div>
          <div className="number"><div className="number-inner">{this.state.number[4]}</div></div>
          <div className="number"><div className="number-inner">{this.state.number[5]}</div></div>
        </div>
      </div>

    );
  }

  start() {
    if(!this.played) {
      var self = this;
      this.played = true;
      this.interval = setInterval(()=>{
        let n = this.state.n;
        n += this.add;

        this.add *= 1.2;

        let nString = Math.floor(n).toString();
        switch(nString.length) {
          case 1:
            nString = '00000'+nString;
          break;
          case 2:
            nString = '0000'+nString;
          break;
          case 3:
            nString = '000'+nString;
          break;
          case 4:
            nString = '00'+nString;
          break;
          case 5:
            nString = '0'+nString;
          break;
          case 6:
          break;
        }

        if(n >= this.state.end) {
          this.setState({n: n, number: this.state.end.toString()});
          clearInterval(this.interval);
        } else {
          this.setState({n: n, number: nString});
        }
      }, 30);
    }

  }
}

export default CountUp;



// WEBPACK FOOTER //
// ./src/js/CountUp.js